<template>
  <div class="h-full">
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <Toaster />
    <FloatingVoice />
    <UpgradeModal
      :is-open="isUpgradeModalOpen"
      :required-plan="requiredPlanForFeature"
      @update:is-open="isUpgradeModalOpen = $event"
    />
  </div>
</template>

<script setup lang="ts">
import { useUpgradeModal } from '~/composables/useUpgradeModal'
import UpgradeModal from '~/components/shared/UpgradeModal.vue'
import { Toaster } from '@/components/ui/toast'
import { useUserStore } from '@/stores/user'
import FloatingVoice from '@/components/voice/FloatingVoice.vue'

const { isUpgradeModalOpen, requiredPlanForFeature } = useUpgradeModal()

// Check user login status on app load
const userStore = useUserStore()
userStore.checkLoginStatus()
</script>
